import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import align from 'dom-align';
import addEventListener from './addEventListener'; //import isWindow from './isWindow';

function isWindow(obj) {
  /* eslint no-eq-null: 0 */

  /* eslint eqeqeq: 0 */
  return obj != null && obj == obj.window;
}

function buffer(fn, ms) {
  var timer;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;
  return bufferFn;
}

var propTypes = {
  childrenProps: PropTypes.object,
  align: PropTypes.object.isRequired,
  target: PropTypes.func,
  onAlign: PropTypes.func,
  monitorBufferTime: PropTypes.number,
  monitorWindowResize: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any
};
var defaultProps = {
  target: function target() {
    return window;
  },
  onAlign: function onAlign() {},
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};

var Align = /*#__PURE__*/function (_React$Component) {
  _inherits(Align, _React$Component);

  var _super = _createSuper(Align);

  function Align(_props) {
    var _this;

    _classCallCheck(this, Align);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "startMonitorWindowResize", function () {
      if (!_this.resizeHandler) {
        _this.bufferMonitor = buffer(_this.forceAlign, _this.props.monitorBufferTime);
        _this.resizeHandler = addEventListener(window, 'resize', _this.bufferMonitor);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "stopMonitorWindowResize", function () {
      if (_this.resizeHandler) {
        _this.bufferMonitor.clear();

        _this.resizeHandler.remove();

        _this.resizeHandler = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "forceAlign", function () {
      var props = _this.props;

      if (!props.disabled) {
        var source = ReactDOM.findDOMNode(_assertThisInitialized(_this));
        props.onAlign(source, align(source, props.target(), props.align));
      }
    });

    return _this;
  }

  _createClass(Align, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var props = this.props; // if parent ref not attached .... use document.getElementById

      this.forceAlign();

      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        if (prevProps.disabled || prevProps.align !== props.align) {
          reAlign = true;
        } else {
          var lastTarget = prevProps.target();
          var currentTarget = props.target();

          if (isWindow(lastTarget) && isWindow(currentTarget)) {
            reAlign = false;
          } else if (lastTarget !== currentTarget) {
            reAlign = true;
          }
        }
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          childrenProps = _this$props.childrenProps,
          children = _this$props.children;
      var child = React.Children.only(children);

      if (childrenProps) {
        var newProps = {};

        for (var prop in childrenProps) {
          if (childrenProps.hasOwnProperty(prop)) {
            newProps[prop] = this.props[childrenProps[prop]];
          }
        }

        return /*#__PURE__*/React.cloneElement(child, newProps);
      }

      return child;
    }
  }]);

  return Align;
}(React.Component);

;
Align.defaultProps = defaultProps;
Align.propTypes = propTypes;
export default Align;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/Align.js